import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface UpdateDeliveryPriceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (deliveryPrice: number) => void;
  currentPrice: number;
  loading?: boolean;
}

const UpdateDeliveryPriceModal: React.FC<UpdateDeliveryPriceModalProps> = ({
  isOpen,
  onClose,
  onUpdate,
  currentPrice,
  loading = false
}) => {
  const { t } = useTranslation();
  const [deliveryPrice, setDeliveryPrice] = useState(currentPrice.toString());

  useEffect(() => {
    if (isOpen) {
      setDeliveryPrice(currentPrice.toString());
    }
  }, [isOpen, currentPrice]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const price = parseInt(deliveryPrice);
    if (!isNaN(price) && price >= 0) {
      onUpdate(price);
    }
  };

  const handleClose = () => {
    setDeliveryPrice(currentPrice.toString());
    onClose();
  };

  const isValid = () => {
    const price = parseInt(deliveryPrice);
    return !isNaN(price) && price >= 0 && price !== currentPrice;
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.updateDeliveryPrice.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div className="modal-form-group">
          <label htmlFor="deliveryPrice">{t('modals.updateDeliveryPrice.priceLabel')}</label>
          <input
            type="number"
            id="deliveryPrice"
            value={deliveryPrice}
            onChange={(e) => setDeliveryPrice(e.target.value)}
            placeholder={t('modals.updateDeliveryPrice.pricePlaceholder')}
            min="0"
            required
            disabled={loading}
          />
          <small className="form-hint">
            {t('modals.updateDeliveryPrice.currentPrice')}: {currentPrice.toLocaleString()} soum
          </small>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.updateDeliveryPrice.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !isValid()}
          >
            {loading ? t('modals.updateDeliveryPrice.updating') : t('modals.updateDeliveryPrice.update')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateDeliveryPriceModal;
